// extracted by mini-css-extract-plugin
export default {"noDonation":"noDonation__noDonation--C7ZLK","icon":"noDonation__icon--uZZIC"};